import { Factory } from 'fishery';
import { accountFactory } from '@trukt/factories/accountFactory';
import { Vendor } from '../types/Vendor';

export const vendorFactory = Factory.define<Vendor>(() => ({
  ...accountFactory.build(),
  dotNumber: '868594404756',
  mcNumber: '295055850755',
  preferred: false,
  blacklist: false,
}));
